/* eslint-disable @typescript-eslint/no-explicit-any */

import Specialized from '../../assets/images/Specialized_Expertise.png';
import Delivery from '../../assets/images/On_Time_Delivery.png';
import Tailored from '../../assets/images/Tailored_Solutions.png';
import Data from '../../assets/images/Data_Integrity&Security.png';
import Global from '../../assets/images/Global_Reach.png';
import Uncompromised from '../../assets/images/Uncompromised_Quality.png';
import Support from '../../assets/images/End_to_End_Support.png';
import Systems from '../../assets/images/Future_Ready_Systems.png';
import Carousel from '../Carousel';

const features = [
  { title: 'Specialized Expertise', description: 'Our multidisciplinary team brings decades of experience in excipients, formulations, and regulatory affairs, enabling us to deliver precise, practical, and innovative solutions for our clients.', image: Specialized },
  { title: 'On-Time Delivery', description: 'We understand the value of time in regulatory approvals. FDAc ensures every project is executed within agreed timelines, aligned with global health authority expectations.', image: Delivery },
  { title: 'Tailored Solutions', description: 'No two companies are the same. We provide strategies customized to your requirements while maintaining full compliance with FDA, EMA, CDSCO, and other agencies.', image: Tailored },
  { title: 'Data Integrity & Security', description: 'We operate with robust data handling systems, ensuring every document, filing, and report is safeguarded with complete confidentiality and accuracy.', image: Data },
  { title: 'Global Reach', description: 'From the US to Latin America, Europe, and Asia, we support global registrations, DMF filings, and GMP compliance with strong regional expertise.', image: Global },
  { title: 'Uncompromised Quality', description: 'Our goal is simple—consistent quality that accelerates approvals. Every FDAC project is benchmarked against international best practices.', image: Uncompromised },
  { title: 'End-to-End Support', description: 'From R&D setup to regulatory submissions and lifecycle management, we support the complete pharmaceutical value chain under one roof.', image: Support },
  { title: 'Future-Ready Systems', description: 'Leveraging advanced digital tools and cloud-based solutions, we help clients work smarter, faster, and with seamless transparency in a real-time environment.', image: Systems },
];

const FeatureCard = ({ feature }:{ feature:any }) => (
  <div className="bg-white rounded-lg overflow-hidden h-full flex flex-col shadow-md">
    <img
      src={feature.image}
      alt={feature.title}
      className="w-full h-40 object-cover"
    />
    <div className="p-4 text-left flex-grow">
      <h3 className="text-[#05326D] font-bold text-lg mb-2">
        {feature.title}
      </h3>
      <p className="text-[#05326D] text-sm">{feature.description}</p>
    </div>
  </div>
);

const WhyFDASection = () => {
  const featureCards = features.map((feature, index) => (
    <FeatureCard key={index} feature={feature} />
  ));

  return (
    <Carousel
      title="Why FDA consultancy Pvt Ltd"
      subtitle="At FDAc, we measure our success by the value we create for our clients. Every service we provide is built around one goal—helping pharmaceutical innovators bring safe, effective, and compliant solutions to patients faster and smarter."
      itemsPerPageConfig={{
        mobile: 1,
        tablet: 1,
        desktop: 3,
        large: 4
      }}
      backgroundColor="bg-gradient-to-b from-[#F0F9FC] to-[#B7E0F1]"
      showArrows={true}
      showDots={true}
      gap="gap-6"
      className="py-16"
    >
      {featureCards}
    </Carousel>
  );
};

export default WhyFDASection;
